import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { CustomFieldModel } from '@smarttask-common/src/lib/models/CustomField/Core/CustomFieldModel';

export enum CustomFieldActionTypes {
    ADD_CUSTOM_FIELD = '[CustomField] Create CustomField',
    ADD_CUSTOM_FIELDS = '[CustomField] Add CustomFields',
    UPSERT_CUSTOM_FIELD = '[CustomField] Upsert CustomField',
    UPSERT_CUSTOM_FIELDS = '[CustomField] Upsert CustomFields',
    UPDATE_CUSTOM_FIELD = '[CustomField] Update CustomField',
    UPDATE_CUSTOM_FIELDS = '[CustomField] Update CustomFields',
    DELETE_CUSTOM_FIELD = '[CustomField] Delete CustomField',
    DELETE_CUSTOM_FIELDS = '[CustomField] Delete CustomFields',
    DELETE_ALL_CUSTOM_FIELDS = '[CustomField] Delete All CustomFields',
    DELETE_ALL = '[CustomField] Delete All',

    UPDATE_SELECTED_ID = '[custom_field] Update SelectedId',
}

export class UpdateSelectedCustomFieldId implements Action {
    readonly type = CustomFieldActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_custom_field_id: string) {}
}

export class AddOne implements Action {
    readonly type = CustomFieldActionTypes.ADD_CUSTOM_FIELD;
    constructor(public custom_field: CustomFieldModel) {}
}

export class AddMany implements Action {
    readonly type = CustomFieldActionTypes.ADD_CUSTOM_FIELDS;
    constructor(public custom_fields: Array<CustomFieldModel>) {}
}

export class UpsertOne implements Action {
    readonly type = CustomFieldActionTypes.UPSERT_CUSTOM_FIELD;

    constructor(public custom_field: CustomFieldModel) {}
}

export class UpsertMany implements Action {
    readonly type = CustomFieldActionTypes.UPSERT_CUSTOM_FIELDS;
    constructor(public custom_fields: Array<CustomFieldModel>) {}
}

export class UpdateOne implements Action {
    readonly type = CustomFieldActionTypes.UPDATE_CUSTOM_FIELD;
    constructor(public custom_field: Update<CustomFieldModel>) {}
}

export class UpdateMany implements Action {
    readonly type = CustomFieldActionTypes.UPDATE_CUSTOM_FIELDS;
    constructor(public custom_fields: Array<Update<CustomFieldModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = CustomFieldActionTypes.DELETE_CUSTOM_FIELD;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = CustomFieldActionTypes.DELETE_CUSTOM_FIELDS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = CustomFieldActionTypes.DELETE_ALL_CUSTOM_FIELDS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = CustomFieldActionTypes.DELETE_ALL;
    constructor() {}
}

export type CustomFieldActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedCustomFieldId;
